import { Tooltip } from "../../../Tooltip/Tooltip"

const TypeFilter = (props) => {
    const { name, changed, clicked, isSelected, properties } = props;
    return(
         <>
        <div className="c-typeFilter__container">
            <input 
                className="c-typeFilter"
                type="radio" 
                id= {properties.id} 
                name= {name} 
                value= {properties.value}
                onChange= {(evt) => {changed(evt.target)}}
                onClick= {(evt) => {clicked(evt.target)}}
                checked = {isSelected}
            />
            <label htmlFor= {properties.id}>
                <p className="c-typeFilter__alt">{properties.alt}</p>
                <span className={properties.filterClass}></span>
            </label>
            <div className="c-typeFilter-tooltip">
                <Tooltip 
                    arrowPosition={"bottom"} 
                    tooltipText={properties.alt}
                />
            </div>
        </div>
        
       </>
    );
}

export default TypeFilter